import { styled, media, selectTheme } from '@creditas-ui/react';

const StepperContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  overflow: hidden;
  width: auto;

  .active {
    background: ${selectTheme('colors.primary.40')};
    color: ${selectTheme('colors.neutral.90')};
  }

  .disabled {
    background: ${selectTheme('colors.neutral.40')};
  }

  .checked {
    background: ${selectTheme('colors.neutral.90')};
  }

  ${media.down('4xl')} {
    justify-content: flex-start;
    padding: 18px 0px;
    margin-bottom: 32px;
    overflow: visible;
  }
`;

const StepperItem = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  white-space: nowrap;
`;

const StepperCount = styled.div`
  align-items: center;
  border-radius: 50%;
  color: ${selectTheme('colors.neutral.0')};
  display: flex;
  font-size: 14px;
  height: 24px;
  justify-content: center;
  min-height: 24px;
  min-width: 24px;
  text-align: center;
  width: 24px;
`;

const StepperLine = styled.div`
  background: ${selectTheme('colors.neutral.15')};
  height: 1px;
  width: 24px;

  ${media.down('2xl')} {
    display: none;
  }
`;

export { StepperContainer, StepperItem, StepperCount, StepperLine };
